var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';



const ListOfItems = ({ items }) => /*#__PURE__*/
_jsx("ul", { className: "flex flex-wrap gap-8 max-w-md list-disc list-inside" }, void 0,
items.length ?
items.map((item) =>
'username' in item.original ? /*#__PURE__*/
_jsx("li", {}, item.original._id, item.original.username) : /*#__PURE__*/

_jsx("li", {}, item.original._id, item.original.name)

) :
null
);


export { ListOfItems };